import { graphql, useStaticQuery } from 'gatsby';
import { ShoppingBanner } from '@contracts';

export const query = graphql`
  query getShoppingBanners {
    allPrismicVitalsShoppingBanner {
      nodes {
        uid
        lang
        data {
          title {
            text
          }
          text {
            text
            richText
          }
          button_text
          button_link
          show_in_countries
          main_image_horizontal {
            gatsbyImageData
            url
            alt
          }
          main_image_vertical {
            gatsbyImageData
            url
            alt
          }
          background_color
          background_image_horizontal {
            gatsbyImageData
            url
            alt
          }
          background_image_vertical {
            gatsbyImageData
            url
            alt
          }
        }
      }
    }
  }
`;

interface ShoppingBannerPrismicNodes {
  nodes: ShoppingBannerFromPrismic[];
}

interface ShoppingBannerFromPrismic {
  uid: string;
  data: ShoppingBanner;
}

export const getShoppingBanners = () => {
  const { allPrismicVitalsShoppingBanner } = useStaticQuery(query);
  const { nodes } = allPrismicVitalsShoppingBanner as ShoppingBannerPrismicNodes;

  const shoppingBanners: ShoppingBanner[] = nodes.map((node) => {
    return {
      ...node.data,
      uid: node.uid
    } as ShoppingBanner;
  });

  return shoppingBanners;
};
